import isNil from 'lodash/isNil'
import { AssigneeEntity, EmailAssigneeVariable } from '@omnea-app/core/blocks'
import { AssigneeTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { FormQuestionVariable, Variable } from '@omnea-app/packages/universal/workflow/workflowVariables'
import { ASSESSMENT_OWNER_ID, REQUESTOR_ID } from '@omnea-app/requests/variableAssigneeTypes'

function isFormQuestionVariable(variable: Variable): variable is FormQuestionVariable {
  return (variable as FormQuestionVariable).inputType !== undefined
}

export const requestorAssignee = {
  value: 'Requestor',
  id: REQUESTOR_ID,
  type: AssigneeTypeEnum.VARIABLE,
  name: 'Requestor',
}

export const assessmentOwnerAssignee = {
  value: 'Business Owner',
  id: ASSESSMENT_OWNER_ID,
  type: AssigneeTypeEnum.VARIABLE,
  name: 'Business Owner',
}

// Email variables we support in sending notifications to
export const emailAssigneeVariables: Record<
  EmailAssigneeVariable,
  { value: string; id: string; type: AssigneeTypeEnum.VARIABLE }
> = {
  supplierPortalAssignees: {
    value: 'Supplier Portal Assignees',
    id: 'supplierPortalAssignees',
    type: AssigneeTypeEnum.VARIABLE,
  },
  primaryContactEmail: {
    value: 'Primary Contact Email',
    id: 'primaryContactEmail',
    type: AssigneeTypeEnum.VARIABLE,
  },
}

export const getVariableAssignees = (
  variables: Variable[],
  {
    includeRequestor,
    includeAssessmentOwner,
    includeEmailAssignees = false,
  }: { includeRequestor: boolean; includeAssessmentOwner: boolean; includeEmailAssignees?: boolean }
) => {
  const assigneesFromIntakeFormVariables = variables.reduce((acc: AssigneeEntity[], item: Variable): AssigneeEntity[] => {
    const isFormQuestion = isFormQuestionVariable(item)

    if (!isFormQuestion) return acc

    if (isFormQuestion && (item.inputType === 'assignees' || item.inputType === 'user')) {
      const variable = {
        value: !isNil(item.label) && item.label.trim() !== '' ? item.label : item.name,
        id: item.name,
        type: AssigneeTypeEnum.VARIABLE,
        name: item.name,
      }

      return [...acc, variable]
    }

    if (includeEmailAssignees) {
      const variable = emailAssigneeVariables[item.name as EmailAssigneeVariable]

      if (variable) {
        return [...acc, variable]
      }
    }

    return acc
  }, [])
  if (includeRequestor) assigneesFromIntakeFormVariables.push(requestorAssignee)
  if (includeAssessmentOwner) assigneesFromIntakeFormVariables.push(assessmentOwnerAssignee)

  return assigneesFromIntakeFormVariables
}
